export * from './birth-bulk-edit.component';
export * from './birth-bulk-templates.component';
